import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'filter-board-svg',
  templateUrl: './filter-board-svg.component.html',
  styleUrls: ['./../../svg.scss']
})
export class FilterBoardSvgComponent {
  @Input() active:boolean=false;
  constructor() { }
}
